import { createSlice } from '@reduxjs/toolkit'

const initialState = {}

const viewStateSlice = createSlice({
  name: 'viewState',
  initialState,
  reducers: {
    setViewState: (state, { payload }) => {
      const { key, patch } = payload

      if (!key || !patch) {
        return
      }

      state[key] = {
        ...(state[key] || {}),
        ...patch,
      }
    },
    resetViewState: (state, { payload }) => {
      delete state[payload]
    },
    resetAllViewState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase('user/logout', () => initialState)
  },
})

export const { setViewState, resetViewState, resetAllViewState } = viewStateSlice.actions
export default viewStateSlice.reducer
